<template>
	<o-section :title="`${setup.specificAvailabilityEntity.isNew ? `Ajout d'une nouvelle` : `Modification de la`} disponibilité particulière`">
		<o-datepicker
			v-model:range="setup.period"
			label="Semaine"
			type="week"
			required
			:min-date="new Date().setDateToFirstDow()"
			:value-display-format="setup.weekPickerCustomValueDisplay"/>

		<user-profile-availability-flagged-week
			v-if="setup.period"
			:availability-entity="setup.specificAvailabilityEntity"
			:week-dates="setup.period"/>

		<o-button
			class="add-period"
			:color="setup.specificAvailabilityEntity.isNew ? 'success' : 'info' "
			block
			@click="setup.specificAvailabilityEntity.isNew
				? setup.addAsync()
				: setup.updateAsync()">
			{{ setup.specificAvailabilityEntity.isNew ? 'Ajouter cette période' : 'Enregistrer les modifications' }}
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import UserProfileSpecificAvailabilitiesAsideNewSetupService from '@/setup/user-profile/UserProfileSpecificAvailabilitiesAsideNewSetupService';
import { inject } from 'vue';
import UserProfileAvailabilityFlaggedWeek from './UserProfileAvailabilityFlaggedWeek.vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(UserProfileSpecificAvailabilitiesAsideNewSetupService.props);
const setup = new UserProfileSpecificAvailabilitiesAsideNewSetupService(props, _aside);
</script>

<style scoped lang="less">
.add-period {
	margin-top: 1rem;
}
</style>
